import base from './base';

export default {
  ...base,
  name: 'test',
  herbieApiHost: 'https://api-testing-not-valid.com',
  apiHost: 'https://api-testing-not-valid.com',
  apiV2: 'https://api-testing-not-valid.com',
  experience: 'https://api-testing-not-valid.com',
  sentryDsn: 'https://sentry-testing-not-valid.com',
  segmentAnalyticsKey: 'segment-test-not-valid',
  googleMapsKey: '',
  cobliInviteUrl: 'https://cadastro-test.cobli.co/invites',
  graphqlHost: 'https://api-testing-not-valid.co/graphql',
  cerberusHost: '',
  launchDarklyId: '5b69f3c2ffcc3e1ec6336136',
  geofenceApiHost: 'https://api.cobli.co/v3/geofences',
  alertsApiHost: 'https://api.cobli.co/v1/triggers',
};
